import { render, staticRenderFns } from "./ButtonStandard.vue?vue&type=template&id=703441e2&"
import script from "./ButtonStandard.vue?vue&type=script&lang=js&"
export * from "./ButtonStandard.vue?vue&type=script&lang=js&"
import style0 from "./ButtonStandard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports